export default __webpack_public_path__ + "static/media/1654.ec295c66.png";